import { FiresideChatsTable } from "./firesideChats";

const supabaseData = {
  firesideChats: new FiresideChatsTable()
};

export default supabaseData;
